export default {
	data() {
		return {
			filterIsFrontOrder: { field: "is_front_order", index: null }
		};
	},
	watch: {
		"filterIsFrontOrder.index": {
			handler(newVal) {
				let val = this.filterIsFrontOrder;
				if (val.index != null && val.index !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.index });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	}
};
